angular.module('FlexyBeautyApp.services')
    .factory('OfferResource', ["$resource", function ($resource) {
        let baseUrl = location.origin;
        return $resource(baseUrl + '/rest/offers', {}, {
            listCompanyOfferUsages: {method: 'GET', isArray: false , url:baseUrl+'/rest/offers/usage-history-per-offer'}
        });
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('OfferService', ["OfferResource", function (OfferResource) {
        return {
            allOffers: [],
            findAll: function () {
                return OfferResource.query().$promise;
            },
            computeUsageHistoryPerOffer: function (companyCode) {
                return OfferResource.listCompanyOfferUsages({companyCode: companyCode}).$promise;
            }
        };
    }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('Offer', [function () {
        return {
            code: '',
            label: '',
            storeAppCodes: [],
            price: 0.0,
            position: 0,
            timeCreated: 0,
            timeModified: 0
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/models/Offer.js